import React, { useContext, useState } from "react";
import { logout } from "auth";
import {
  Button,
  Box,
  Divider,
  Typography,
  Stack,
  Avatar,
  Icon,
  Popover,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Menu from "common/components/Menu";
import { darken } from "@mui/material";
import SidePanel from "common/components/SidePanel";
import { UserPasswordUpdate } from "pages/Crew";
import { ReactComponent as AdminAvatar } from "assets/crew/admin_avatar.svg";
import { ReactComponent as EngineerAvatar } from "assets/crew/engineer_avatar.svg";
import { ReactComponent as OperatorAvatar } from "assets/crew/operator_avatar.svg";
import { ReactComponent as AuditorAvatar } from "assets/crew/auditor_avatar.svg";
import { GlobalContext } from "index";

const roleIcon = {
  auditor: AuditorAvatar,
  engineer: EngineerAvatar,
  operator: OperatorAvatar,
  admin: AdminAvatar,
};

export default function AccountPopover() {
  const { user } = useContext(GlobalContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const [resetPass, setResetPass] = useState(false);
  const handleMouseEnter = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMouseLeave = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "name-popover" : undefined;
  const navigate = useNavigate();
  const logoutHandler = () => {
    logout();
  };
  let RbacAvatar = roleIcon[user?.rls || "operator"];
  const darkerColor = darken(user?.color || "#000", 0.8);
  const avatar = (
    <Avatar
      sx={{
        width: 40,
        height: 40,
        border: `${user?.color} 2px solid`,
        backgroundColor: `${user?.color}`,
        borderRadius: "50%",
      }}
    >
      <RbacAvatar fill={darkerColor} />
    </Avatar>
  );
  return (
    <>
      <SidePanel
        open={resetPass}
        closeDrawer={() => setResetPass(false)}
        props={{ user, saveUser: () => {} }}
      >
        {UserPasswordUpdate}
      </SidePanel>
      <Menu icon={avatar}>
        {() => (
          <>
            <Box sx={{ minWidth: "200px", my: 1.5, px: 2.5 }}>
              <Stack alignItems="center" spacing={3} direction="row">
                <Stack>
                  <Typography
                    variant="subtitle1"
                    noWrap
                    sx={{
                      maxWidth: "200px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "inline-block",
                    }}
                    aria-owns={open ? id : undefined}
                    aria-haspopup="true"
                    onMouseEnter={handleMouseEnter}

                    // onMouseLeave={handleMouseLeave}
                  >
                    {user?.id}
                  </Typography>
                  <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleMouseLeave}
                    PaperProps={{
                      onMouseLeave: handleMouseLeave,
                    }}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                  >
                    <Typography sx={{ p: 1 }}>{user?.id}</Typography>
                  </Popover>
                  <Stack>
                    <Typography variant="caption" noWrap>
                      <strong>crew:</strong> {user?.crew_name}
                    </Typography>
                    <Typography variant="caption" sx={{}} noWrap>
                      <strong>role:</strong> {user?.role}
                    </Typography>
                  </Stack>
                  {/* <Typography variant="body2" sx={{}} noWrap>
                {user?.rls}
              </Typography> */}
                </Stack>
              </Stack>
            </Box>

            <Divider sx={{ my: 1 }} />
            <Stack spacing={2} sx={{ p: 2, pt: 1.5 }}>
              <Button
                onClick={() => {
                  let { access_token } = JSON.parse(
                    localStorage?.getItem("E1_JWT") || "{}"
                  );
                  window.open(
                    `${window.location.protocol}//${window.location.host}/docs?token=${access_token}`
                  );
                }}
                fullWidth
                color="inherit"
                variant="outlined"
              >
                <Icon sx={{ color: "#fff !important", marginRight: "10px" }}>
                  school
                </Icon>
                Documentation
              </Button>
              {!user?.sso ? (
                <Button
                  onClick={() => {
                    setResetPass(true);
                  }}
                  fullWidth
                  color="inherit"
                  variant="outlined"
                >
                  <Icon sx={{ color: "#fff !important", marginRight: "10px" }}>
                    key
                  </Icon>
                  Change Password
                </Button>
              ) : null}
              <Button
                onClick={logoutHandler}
                fullWidth
                sx={{ borderColor: "#a84d4d" }}
                color="inherit"
                variant="outlined"
              >
                Logout
              </Button>
            </Stack>
          </>
        )}
      </Menu>
    </>
  );
}
